module.exports = __webpack_public_path__ + "media/efdab_1.1d.3f0609f5.mp3";